import type { PropsWithClassName } from "@models/types/index";
import { PropsWithChildren } from "react";
import { Link } from "@shopify/hydrogen";

interface Props extends PropsWithChildren, PropsWithClassName {
  to: string;
  closeSearch?: () => void;
}

export function CustomLink({ className, closeSearch, ...others }: Props) {
  return (
    <Link
      className={`overflow-hidden text-ellipsis uppercase text-custom-blue ${className}`}
      onClick={closeSearch}
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
      }}
      {...others}
    />
  );
}
